module.exports = __webpack_public_path__ + "img/FeatureBookingExampleCompressed.59cd5c39.png";